import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Chiave localStorage + versione: bump della versione = ri-chiede il consenso a tutti
const STORAGE_KEY = "palazzolo_cookie_consent_v1";
// Evento per riaprire il banner (es. link "Preferenze cookie" nel footer)
export const OPEN_PREFERENCES_EVENT = "open-cookie-preferences";

// Applica la scelta dell'utente a Google (Consent Mode v2) e PostHog.
function applyConsent(granted) {
  const value = granted ? "granted" : "denied";
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: value,
      ad_user_data: value,
      ad_personalization: value,
      analytics_storage: value,
    });
    // Al consenso registriamo la pagina corrente (la page_view iniziale era bloccata)
    if (granted) {
      window.gtag("event", "page_view", {
        page_path: window.location.pathname + window.location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }
  if (window.posthog) {
    if (granted) window.posthog.opt_in_capturing();
    else window.posthog.opt_out_capturing();
  }
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Applica la scelta gia' salvata; se assente, mostra il banner.
    let saved = null;
    try {
      saved = localStorage.getItem(STORAGE_KEY);
    } catch (_) {
      /* localStorage non disponibile */
    }
    if (saved === "granted") applyConsent(true);
    else if (saved === "denied") applyConsent(false);
    else setVisible(true);

    // Riapertura dal footer ("Preferenze cookie")
    const reopen = () => setVisible(true);
    window.addEventListener(OPEN_PREFERENCES_EVENT, reopen);
    return () => window.removeEventListener(OPEN_PREFERENCES_EVENT, reopen);
  }, []);

  const choose = (granted) => {
    try {
      localStorage.setItem(STORAGE_KEY, granted ? "granted" : "denied");
    } catch (_) {
      /* ignora */
    }
    applyConsent(granted);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      role="dialog"
      aria-live="polite"
      aria-label="Informativa sui cookie"
      className="fixed inset-x-0 bottom-0 z-[100] p-4 sm:p-6"
    >
      <div className="max-w-[1100px] mx-auto bg-[#0b0b0b]/95 backdrop-blur border border-[#C9A961]/30 shadow-2xl px-6 py-6 sm:px-8 sm:py-7">
        <div className="flex flex-col lg:flex-row lg:items-center gap-6">
          <div className="flex-1">
            <div className="font-display-sc text-[10px] tracking-[0.35em] text-[#C9A961] mb-2">
              Privacy &amp; Cookie
            </div>
            <p className="text-sm leading-relaxed text-white/70">
              Usiamo cookie tecnici necessari e, previo tuo consenso, cookie di
              analisi (Google Analytics e PostHog) per capire come viene usato il
              sito e migliorarlo. Puoi accettare o rifiutare. Maggiori dettagli
              nella{" "}
              <Link
                to="/cookie-policy"
                className="text-[#C9A961] hover:text-[#E0C087] underline underline-offset-2"
                onClick={() => setVisible(false)}
              >
                Cookie Policy
              </Link>
              .
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <button
              type="button"
              data-testid="cookie-reject"
              onClick={() => choose(false)}
              className="px-6 h-11 border border-white/25 text-white/80 hover:border-white/60 hover:text-white text-[11px] uppercase tracking-[0.3em] transition"
            >
              Rifiuta
            </button>
            <button
              type="button"
              data-testid="cookie-accept"
              onClick={() => choose(true)}
              className="px-6 h-11 bg-[#C9A961] text-[#0a0a0a] hover:bg-[#E0C087] text-[11px] uppercase tracking-[0.3em] font-medium transition"
            >
              Accetta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
